<template>
  <v-stepper
    v-model="step"
    non-linear
    vertical
    class="elevation-0"
  >
    <div v-if="hasTitle">
      <div class="px-4 py-3 text-center text-subtitle-2 text-truncate grey--text text--darken-1" v-text="title" />
      <v-divider />
    </div>
    <template v-for="(category, i) in categories">
      <h-step
        :key="`s${i}`"
        :index="i"
      />
      <h-content
        :key="`c${i}`"
        :index="i"
        :disabled="disabled"
        @change="$emit('change')"
        @complete="$emit('complete')"
      />
    </template>
  </v-stepper>
</template>

<script>
  import HStep from './StepperStep'
  import HContent from './StepperContent'

  export default {
    components: {
      HStep,
      HContent,
    },

    props: {
      disabled: {
        required: false,
        type: Boolean,
        default: false,
      },
    },

    computed: {
      step: {
        get () {
          return this.$store.state.orders.modifiers.step
        },
        set (v) {
          this.$store.commit('orders/modifiers/step', v)
        },
      },
      categories () {
        return this.$store.state.orders.modifiers.categories
      },
      title () {
        return this.$store.getters['orders/modifiers/title']
      },
      hasTitle () {
        return this.title != ''
      },
    },
  }
</script>
